import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import GalleryGrid from '../../../../../core/components/GalleryGrid';
import Uploader from '../../../../../core/components/Uploaders/Uploader';
import Image from '../../../../../core/components/Uploaders/Image';
const StyledGalleryGrid = styled(GalleryGrid) `
  ${({ uploadLoading }) => uploadLoading && `cursor: wait !important;`}
`;
const ImagesGallery = ({ uploading, uploaded, progress, removeFile, uploadLoading, rejected, retry, }) => {
    const allFiles = [...uploaded, ...uploading];
    return (React.createElement(StyledGalleryGrid, { items: allFiles, uploadLoading: uploadLoading }, (file) => {
        if (!(file === null || file === void 0 ? void 0 : file.fileId)) {
            return (React.createElement(Image, { key: file === null || file === void 0 ? void 0 : file.name, "data-qa-anchor": "post-creator-uploaded-image", file: file, progress: progress[file === null || file === void 0 ? void 0 : file.name], isRejected: rejected.includes(file === null || file === void 0 ? void 0 : file.name), retry: retry }));
        }
        const { fileId } = file;
        return (React.createElement(Image, { key: fileId, fileId: fileId, "data-qa-anchor": "post-creator-uploaded-image", onRemove: () => removeFile(file) }));
    }));
};
const Images = ({ files, onChange, onLoadingChange, uploadLoading, onError }) => (React.createElement(Uploader, { files: files, onChange: onChange, onLoadingChange: onLoadingChange, onError: onError },
    React.createElement(ImagesGallery, { uploadLoading: uploadLoading })));
Images.propTypes = {
    files: PropTypes.array,
    uploadLoading: PropTypes.bool,
    onLoadingChange: PropTypes.func,
    onChange: PropTypes.func,
    onError: PropTypes.func,
};
Images.defaultProps = {
    files: [],
    onChange: () => { },
    onError: () => { },
    onLoadingChange: () => { },
    uploadLoading: false,
};
export default Images;
//# sourceMappingURL=ImagesUploaded.js.map